
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/querty/login",
      function () {
        return require("private-next-pages/querty/login.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/querty/login"])
      });
    }
  